import { ANNUAL } from 'self-service-api/constants/Terms';
import { AnnualBillingTermTextComponent, BillingTermSubtextComponent, CostToGetStartedSection, MonthlyPriceDisplay } from './SummaryColumnPriceDisplayComponents';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const SummaryColumnPriceDisplaySection = ({
  annualCostPrice,
  annualListPrice,
  monthlyCostPrice,
  activeCurrencyCode,
  term,
  costToGetStarted,
  showTotalPriceAsterisk = false
}) => {
  const hasPrice = monthlyCostPrice > 0;
  const hasGreaterStartingCost = costToGetStarted > 0 && costToGetStarted > (term === ANNUAL ? annualCostPrice : monthlyCostPrice);
  const hasHiddenCost = costToGetStarted > 0 && showTotalPriceAsterisk;
  const showCostToGetStarted = hasGreaterStartingCost || hasHiddenCost;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(MonthlyPriceDisplay, {
      price: monthlyCostPrice,
      currencyCode: activeCurrencyCode,
      annualListPrice: annualListPrice,
      annualCostPrice: annualCostPrice
    }), term && hasPrice && term === ANNUAL && /*#__PURE__*/_jsx(AnnualBillingTermTextComponent, {
      annualListPrice: annualListPrice,
      annualCostPrice: annualCostPrice,
      currencyCode: activeCurrencyCode,
      showCostToGetStarted: showCostToGetStarted
    }), /*#__PURE__*/_jsx(BillingTermSubtextComponent, {
      term: term,
      hasPrice: hasPrice
    }), showCostToGetStarted && /*#__PURE__*/_jsx(CostToGetStartedSection, {
      costToGetStarted: costToGetStarted,
      currencyCode: activeCurrencyCode,
      showTotalPriceAsterisk: showTotalPriceAsterisk
    })]
  });
};